module.exports = __webpack_public_path__ + "img/cctvinspection_stopped.141392e9.svg";